import Layout from "../../components/layouts/Content";
import UserProfile from "./UserProfile";

const UserPage = () => {
	return (
		<Layout>
			<UserProfile />
		</Layout>
	);
};

export default UserPage;
